/**
 * @file meetingStatus.ts
 * @brief Boardroom meeting status enum, alone so node:test can import it.
 *
 * @details
 * Mirrors BoardroomMeetingStatus. Re-exported by `./schemas` (company
 * scope) and imported by `features/admin-meetings/schemas` (Super Admin),
 * which has a parse test that cannot resolve the `@/` alias.
 *
 * @author DES
 * @date 30-10-2026
 */

import { z } from "zod";

export const MeetingStatusSchema = z.enum([
  "uploading",
  "processing",
  "resolved_pending",
  "synthesis_processing",
  "ready",
  "error",
]);

export type MeetingStatus = z.infer<typeof MeetingStatusSchema>;
